import { Spinner } from 'components/Spinner';
import dynamic from 'next/dynamic';

export const LazyToastContainer = dynamic(
  () =>
    import('react-toastify').then((mod) => {
      const { ToastContainer: ToastContainerComponent, Slide } = mod;
      // Return the component directly, not wrapped in an object
      const ToastWrapper = (props: Record<string, unknown>) => <ToastContainerComponent transition={Slide} {...props} />;
      return ToastWrapper;
    }),
  { ssr: false, loading: () => <Spinner /> },
);
